(function () {
  function getScrollStep(container) {
    const item = container.querySelector('.product-sales-v3__item');
    if (!item) return 0;
    const styles = window.getComputedStyle(container);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return item.offsetWidth + gap;
  }

  function getActiveIndex(container) {
    const step = getScrollStep(container);
    if (step <= 0) return 0;
    return Math.round(container.scrollLeft / step);
  }

  function updateProgressSegments(container, section) {
    const segments = section.querySelectorAll('.product-sales-v3__progress-segment');
    if (!segments.length) return;

    const activeIndex = getActiveIndex(container);
    segments.forEach((segment, index) => {
      segment.classList.toggle('is-active', index === activeIndex);
    });
  }

  function initProductSalesV3(section) {
    const root = section.classList.contains('product-sales-v3')
      ? section
      : section.querySelector('.product-sales-v3');
    if (!root) return;

    const container = root.querySelector('.product-sales-v3__items-wrapper');
    const progressSegments = root.querySelectorAll('.product-sales-v3__progress-segment');

    if (container && progressSegments.length) {
      const scrollToIndex = (index) => {
        const step = getScrollStep(container);
        if (step <= 0) return;
        const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
        const next = Math.min(Math.max(0, index * step), maxScroll);
        container.scrollTo({ left: next, behavior: 'smooth' });
      };

      const onScroll = () => {
        updateProgressSegments(container, root);
      };

      container.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      progressSegments.forEach((segment) => {
        segment.addEventListener('click', () => {
          const index = Number(segment.dataset.slideIndex);
          if (Number.isNaN(index)) return;
          scrollToIndex(index);
        });
      });

      onScroll();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-sales-v3').forEach(initProductSalesV3);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.product-sales-v3')) {
      initProductSalesV3(event.target);
    }
  });
})();
